// Fonte: UManutContas.dfm — Painel P5, Ds_Banco → tabela Bancos (38 colunas)
// Regra especial: Se Liquidez=1 (Imediata), oferece vincular dados bancários aos empreendimentos
import React, { useState } from 'react';
import { Form, Row, Col, Card, Collapse } from 'react-bootstrap';
import Select from 'react-select';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import aplicarMascara from './mascaras';

// Fonte: UManutContas.dfm, RxDBOperacao (linha 1024) — Tipo_Conta (operação CEF)
var TIPO_CONTA_BANCO = [
  { value: null, label: '(Nenhum)' },
  { value: 1, label: '001' },
  { value: 2, label: '002' },
  { value: 3, label: '003' },
  { value: 6, label: '006' },
  { value: 7, label: '007' },
  { value: 13, label: '013' },
  { value: 22, label: '022' },
  { value: 23, label: '023' },
  { value: 28, label: '028' },
  { value: 37, label: '037' },
  { value: 43, label: '043' },
  { value: 1288, label: '1288' },
  { value: 1292, label: '1292' },
  { value: 3700, label: '3700' },
  { value: 3701, label: '3701' },
  { value: 3702, label: '3702' },
];

// Fonte: UManutContas.dfm, RxDBComboBox11 — Classe
var CLASSE_BANCO = [
  { value: 'A', label: 'A' },
  { value: 'B', label: 'B' },
  { value: 'C', label: 'Caixa' },
];

// Fonte: UManutContas.dfm, RxDBComboBox12 — Items.Strings (linhas 836-841)
var LIQUIDEZ = [
  { value: '1', label: '1 - Imediata' },
  { value: '2', label: '2 - Aplicação' },
  { value: '3', label: '3 - Médio Prazo' },
  { value: '4', label: '4 - Longo Prazo' },
  { value: '5', label: '5 - Capitalização' },
];

var PIX_TIPO = [
  { value: 'C', label: 'CNPJ' },
  { value: 'E', label: 'E-mail' },
  { value: 'T', label: 'Telefone' },
  { value: 'A', label: 'Aleatória' },
];

var FormTipo5 = function(_ref) {
  var formik = _ref.formik;
  var modoEdicao = _ref.modoEdicao;
  var lookups = _ref.lookups;
  var lookupsLoading = _ref.lookupsLoading;

  var bancosLista = (lookups && lookups.bancosLista) ? lookups.bancosLista : [];
  var razoesSociais = (lookups && lookups.razoesSociais) ? lookups.razoesSociais : [];

  var val = function(campo) {
    var v = formik.values['tipo5'] ? formik.values['tipo5'][campo] : undefined;
    return v !== null && v !== undefined ? v : '';
  };

  var handleChange = function(e) {
    formik.setFieldValue('tipo5.' + e.target.name, e.target.value);
  };

  // Campos INT no backend (Compromisso, SeqCaixa, Pg_*) — só aceita dígitos
  var handleChangeInt = function(e) {
    var somenteDigitos = String(e.target.value || '').replace(/\D/g, '');
    formik.setFieldValue('tipo5.' + e.target.name, somenteDigitos);
  };

  var handleMasked = function(name, tipo) {
    return function(e) {
      formik.setFieldValue('tipo5.' + name, aplicarMascara(e.target.value, tipo));
    };
  };

  var valMask = function(campo, tipo) {
    return aplicarMascara(val(campo), tipo);
  };

  var pixTipoSelecionado = val('pix_tipo');

  var [aberto, setAberto] = useState(true);

  return (
    <Card className="shadow-sm mb-3">
      <Card.Header className="py-2 contas-card-header" style={{ cursor: 'pointer' }} onClick={function() { setAberto(!aberto); }}>
        <div className="d-flex justify-content-between align-items-center">
          <strong>Dados do Tipo: Banco</strong>
          {aberto ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
        </div>
      </Card.Header>
      <Collapse in={aberto}>
        <div>
      <Card.Body>
        <Row>
          <Col md={4} className="mb-3">
            <Form.Label className="small mb-1">Nome / Titular *</Form.Label>
            <Form.Control
              type="text" size="sm" name="razao_social"
              value={val('razao_social')} onChange={handleChange}
              maxLength={40} disabled={!modoEdicao}
            />
          </Col>
          <Col md={3} className="mb-3">
            <Form.Label className="small mb-1">Titular *</Form.Label>
            <Form.Control
              type="text" size="sm" name="titular"
              value={val('titular')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">CNPJ</Form.Label>
            <Form.Control
              type="text" size="sm" name="cnpj"
              value={valMask('cnpj', 'cpf')} onChange={handleMasked('cnpj', 'cpf')}
              maxLength={18} disabled={!modoEdicao}
            />
          </Col>
          <Col md={3} className="mb-3">
            <Form.Label className="small mb-1">Banco</Form.Label>
            <Select
              placeholder="Selecione o banco..."
              options={bancosLista}
              isLoading={lookupsLoading}
              value={bancosLista.find(function(b) { return b.value === val('banco'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo5.banco', opt ? opt.value : null);
              }}
              isDisabled={!modoEdicao || lookupsLoading}
              isClearable
              noOptionsMessage={function() { return 'Nenhum banco'; }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Nº Conta</Form.Label>
            <Form.Control
              type="text" size="sm" name="numero_conta"
              value={val('numero_conta')} onChange={handleChange}
              maxLength={20} disabled={!modoEdicao}
            />
          </Col>
          <Col md={1} className="mb-3">
            <Form.Label className="small mb-1">Dígito</Form.Label>
            <Form.Control
              type="text" size="sm" name="dig_conta"
              value={val('dig_conta')} onChange={handleChange}
              maxLength={2} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Agência</Form.Label>
            <Form.Control
              type="text" size="sm" name="agencia"
              value={val('agencia')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={1} className="mb-3">
            <Form.Label className="small mb-1">Dg.Ag</Form.Label>
            <Form.Control
              type="text" size="sm" name="dig_agencia"
              value={val('dig_agencia')} onChange={handleChange}
              maxLength={2} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Classe *</Form.Label>
            <Select
              options={CLASSE_BANCO}
              value={CLASSE_BANCO.find(function(c) { return c.value === val('classe'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo5.classe', opt ? opt.value : '');
              }}
              isDisabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Liquidez *</Form.Label>
            <Select
              options={LIQUIDEZ}
              value={LIQUIDEZ.find(function(l) { return l.value === val('liquidez'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo5.liquidez', opt ? opt.value : '');
              }}
              isDisabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Operação</Form.Label>
            <Select
              options={TIPO_CONTA_BANCO}
              isClearable
              value={TIPO_CONTA_BANCO.find(function(t) { return t.value === val('tipo_conta'); }) || TIPO_CONTA_BANCO[0]}
              onChange={function(opt) {
                formik.setFieldValue('tipo5.tipo_conta', opt ? opt.value : null);
              }}
              isDisabled={!modoEdicao}
            />
          </Col>
        </Row>
        <Row>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Cod. Empresa</Form.Label>
            <Form.Control
              type="text" size="sm" name="cod_empresa"
              value={val('cod_empresa')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={3} className="mb-3">
            {/* Fonte: UManutContas.dfm:976-990 — RxDBLookupCombo5 (dsRazao, razao_social) */}
            <Form.Label className="small mb-1">Cód. Razão</Form.Label>
            <Select
              placeholder="Selecione..."
              options={razoesSociais}
              isLoading={lookupsLoading}
              isClearable
              value={razoesSociais.find(function(r) { return r.value === val('codigo_razao'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo5.codigo_razao', opt ? opt.value : null);
              }}
              isDisabled={!modoEdicao || lookupsLoading}
              noOptionsMessage={function() { return 'Nenhuma razão'; }}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Tipo PIX</Form.Label>
            <Select
              options={PIX_TIPO}
              isClearable
              value={PIX_TIPO.find(function(p) { return p.value === val('pix_tipo'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo5.pix_tipo', opt ? opt.value : null);
              }}
              isDisabled={!modoEdicao}
            />
          </Col>
          {pixTipoSelecionado && (
            <Col md={4} className="mb-3">
              <Form.Label className="small mb-1">Chave PIX *</Form.Label>
              <Form.Control
                type="text" size="sm" name="pix_chave"
                value={val('pix_chave')} onChange={handleChange}
                disabled={!modoEdicao}
              />
            </Col>
          )}
        </Row>

        <Row>
          <Col md={4} className="mb-3">
            <Form.Label className="small mb-1">Endereço</Form.Label>
            <Form.Control
              type="text" size="sm" name="endereco"
              value={val('endereco')} onChange={handleChange}
              maxLength={40} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Fone</Form.Label>
            <Form.Control
              type="text" size="sm" name="fone"
              value={valMask('fone', 'fone')} onChange={handleMasked('fone', 'fone')}
              maxLength={14} disabled={!modoEdicao}
            />
          </Col>
          <Col md={3} className="mb-3">
            <Form.Label className="small mb-1">Contato</Form.Label>
            <Form.Control
              type="text" size="sm" name="contato"
              value={val('contato')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
        </Row>

        {/* Sub-seção Senhas */}
        <div className="contas-section-title mt-2">Senhas</div>
        <Row>
          <Col md={4} className="mb-3">
            <Form.Label className="small mb-1">Senha 1</Form.Label>
            <Form.Control
              type="text" size="sm" name="senha1"
              value={val('senha1')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={4} className="mb-3">
            <Form.Label className="small mb-1">Senha 2</Form.Label>
            <Form.Control
              type="text" size="sm" name="senha2"
              value={val('senha2')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={4} className="mb-3">
            <Form.Label className="small mb-1">Senha 3</Form.Label>
            <Form.Control
              type="text" size="sm" name="senha3"
              value={val('senha3')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
        </Row>

        {/* Sub-seção Recebimento / Caixa — Fonte: UManutContas.dfm P5, campos sem prefixo PG_ */}
        <div className="contas-section-title mt-2">Recebimento / Caixa</div>
        <Row>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Seq. Caixa</Form.Label>
            <Form.Control
              type="text" size="sm" name="seq_caixa"
              inputMode="numeric"
              value={val('seq_caixa')} onChange={handleChangeInt}
              disabled={!modoEdicao} readOnly
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Compromisso</Form.Label>
            <Form.Control
              type="text" size="sm" name="compromisso"
              inputMode="numeric"
              value={val('compromisso')} onChange={handleChangeInt}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Cx. Apelido</Form.Label>
            <Form.Control
              type="text" size="sm" name="cx_apelido"
              value={val('cx_apelido')} onChange={handleChange}
              maxLength={6} disabled={!modoEdicao}
              style={{ textTransform: 'uppercase' }}
            />
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label className="small mb-1">Caminho Cx</Form.Label>
            <Form.Control
              type="text" size="sm" name="caminho_cx"
              value={val('caminho_cx')} onChange={handleChange}
              maxLength={100} disabled={!modoEdicao}
              style={{ textTransform: 'uppercase' }}
            />
          </Col>
        </Row>

        {/* Sub-seção PagFor / Boleto */}
        <div className="contas-section-title mt-2">PagFor / Boleto</div>
        <Row>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Convênio</Form.Label>
            <Form.Control
              type="text" size="sm" name="pg_convenio"
              value={val('pg_convenio')} onChange={handleChange}
              maxLength={8} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Seq. Caixa</Form.Label>
            <Form.Control
              type="text" size="sm" name="pg_seq_caixa"
              inputMode="numeric"
              value={val('pg_seq_caixa')} onChange={handleChangeInt}
              disabled={!modoEdicao} readOnly
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Compromisso</Form.Label>
            <Form.Control
              type="text" size="sm" name="pg_compromisso"
              inputMode="numeric"
              value={val('pg_compromisso')} onChange={handleChangeInt}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Cx. Apelido</Form.Label>
            <Form.Control
              type="text" size="sm" name="pg_cx_apelido"
              value={val('pg_cx_apelido')} onChange={handleChange}
              maxLength={6} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Param. Trans.</Form.Label>
            <Form.Control
              type="text" size="sm" name="pg_param_trans"
              value={val('pg_param_trans')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Par. Trans.</Form.Label>
            <Form.Control
              type="text" size="sm" name="param_trans"
              value={val('param_trans')} onChange={handleChange}
              maxLength={2} disabled={!modoEdicao}
              style={{ textTransform: 'uppercase' }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Comp. Folha</Form.Label>
            <Form.Control
              type="text" size="sm" name="tipo_comp_folha"
              value={val('tipo_comp_folha')} onChange={handleChange}
              maxLength={2} disabled={!modoEdicao}
              style={{ textTransform: 'uppercase' }}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Comp. Fornec</Form.Label>
            <Form.Control
              type="text" size="sm" name="tipo_comp_fornec"
              value={val('tipo_comp_fornec')} onChange={handleChange}
              maxLength={2} disabled={!modoEdicao}
            />
          </Col>
          <Col md={8} className="mb-3">
            <Form.Label className="small mb-1">Caminho Cx</Form.Label>
            <Form.Control
              type="text" size="sm" name="pg_caminho_cx"
              value={val('pg_caminho_cx')} onChange={handleChange}
              maxLength={100} disabled={!modoEdicao}
            />
          </Col>
        </Row>
      </Card.Body>
        </div>
      </Collapse>
    </Card>
  );
};

export default FormTipo5;
